import React, { Component } from 'react';

type Props = {
  onVisible: Function,
  children: React.Node,
  rootMargin: String,
};

type State={}

export default class TrackVisibility extends Component<Props, State> {
  ref = React.createRef();

  async componentDidMount() {
    if (!window?.IntersectionObserver) await import('intersection-observer');

    const { rootMargin } = this.props;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio === 0 || entry.intersectionRatio === 1) {
          this.props.onVisible();
        }
      },
      {
        root: null,
        rootMargin: rootMargin || '0px',
        threshold: [0, 1],
      },
    );
    if (this.ref.current) observer.observe(this.ref.current);
  }

  render() {
    return <div ref={this.ref}> {this.props.children}</div>;
  }
}
